var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.preloaderVisibility)?_c('AspectTableSingleComponents',{attrs:{"editMode":true,"aspectData":_vm.aspectData}}):_c('PreloaderComponent')}
var staticRenderFns = []

export { render, staticRenderFns }